import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ReactPlayer from "react-player"
import { SushiFooter } from '../../components/suishiFooterComponent';


type Props = {
    // languageExchange:any,
}

export const MoviePage: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  const nav = useNavigate();
  const indexPageMainStyle: React.CSSProperties = {
    backgroundColor:'black',

  
    minHeight:'calc(100vh - 60px)',
    textAlign: 'center',
    // backgroundColor: '#00001D',
    fontFamily: "Noto Sans JP,sans-serif",
    width: '100%',
    height:'100vh',
    // overflowX: 'hidden',
    // backgroundImage: "url('https://nfttopshot-template.onrender.com/nandemolabostatic/img/top-bg.png')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
    flex:1,
    color: '#FFFBFB',
    position:'relative'
  };
  const IndexPageDiv = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `;

  React.useEffect(()=>{
    //最上部にスクロール
    window.scrollTo(0,0);
  },[]);

  return (
    <IndexPageDiv>
      <main style={indexPageMainStyle}>
      <ReactPlayer
        url={`https://www.sushitop.io/1qrshot/company/kyoto/nft_gacha_light.mp4`}
        playing={true}
        playsinline
        volume={0}
        width='100%'
        height='100%'
        muted
        //👇 受信完了画面に飛ばす
        onEnded={()=> nav('/8')}
        // onEnded={()=>console.log(`再生終了`)}
      />
      </main>
      <SushiFooter footerPragraph1='powered by' footerPragraph2='- Creating a Token-Graph Marketing Culture -'/>
    </IndexPageDiv>
  );
};